import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import './onboarding/onboarding.css'

const NETLIFY_FUNCTIONS = import.meta.env.VITE_NETLIFY_FUNCTIONS_URL || ''

const MESSAGES = {
  invalid_or_expired_link: 'This link is invalid or has expired. Open the app and log in, or request a new email.',
  link_already_used: 'This link has already been used. Open the app and log in if needed.',
  link_expired: 'This link has expired. Open the app and log in, or request a new email.',
  default: 'Something went wrong. Try opening the app and logging in.'
}

export default function AuthFromEmail() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const [status, setStatus] = useState('loading') // 'loading' | 'redirecting' | 'error'
  const [errorCode, setErrorCode] = useState(null)

  useEffect(() => {
    if (!token || !token.trim()) {
      setStatus('error')
      setErrorCode('invalid_or_expired_link')
      return
    }

    const base = NETLIFY_FUNCTIONS || ''
    const url = base ? `${base}/exchange-email-token?token=${encodeURIComponent(token)}` : `/.netlify/functions/exchange-email-token?token=${encodeURIComponent(token)}`

    fetch(url, { method: 'GET' })
      .then((res) => {
        return res.json().then((body) => ({ ok: res.ok, status: res.status, body }))
      })
      .then(({ ok, body }) => {
        if (ok && body?.url) {
          setStatus('redirecting')
          window.location.href = body.url
          return
        }
        setStatus('error')
        setErrorCode(body?.error || 'invalid_or_expired_link')
      })
      .catch(() => {
        setStatus('error')
        setErrorCode('default')
      })
  }, [token])

  if (status === 'loading' || status === 'redirecting') {
    return (
      <div className="onboarding-container" style={{ padding: 24, textAlign: 'center' }}>
        <p style={{ marginTop: 48 }}>
          {status === 'redirecting' ? 'Logging you in…' : 'Checking link…'}
        </p>
      </div>
    )
  }

  return (
    <div className="onboarding-container" style={{ padding: 24, textAlign: 'center', maxWidth: 400, margin: '48px auto' }}>
      <h1 style={{ fontSize: 20, marginBottom: 16 }}>Link expired or invalid</h1>
      <p style={{ color: '#666', marginBottom: 24 }}>
        {MESSAGES[errorCode] || MESSAGES.default}
      </p>
      <a href="/login" style={{ display: 'inline-block', background: '#000', color: '#fff', padding: '12px 24px', borderRadius: 4, textDecoration: 'none' }}>
        Open login
      </a>
    </div>
  )
}
